export const Navbar = () => {
  return (
    <div>
      <div className="navbar contet-wrapper">
        <div className="message">Sponsor a hackathon with 600+ registrants from 40+ different schools!</div>
        <div
          style={{
            display: "flex",
            gap: "8px",
          }}
        >
          <a
            href="https://drive.google.com/file/d/1kI6QPhuKLsWxyEh-2M4RD3UF5_KqaRnc/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            <button className="button outline">2026 Impact Report</button>
          </a>
          <a
            href="https://calendly.com/sponsor-hackatbrown/prospectus-sponsor-meeting?month=2024-07"
            target="_blank"
            rel="noreferrer"
          >
            <button className="button filled">Schedule a Meeting!</button>
          </a>
        </div>
      </div>
      <div style={{ height: "80px" }}></div>
    </div>
  );
};
